const relatedNewsSlider = document.querySelectorAll('[data-slider="related-news-slider"]');

const relatedNewsSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 8,
  speed: 400,
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

relatedNewsSlider.forEach((el) => new Swiper(el, relatedNewsSliderOptions));
